import React from "react";
import { useNavigate } from "react-router-dom";
import carewindow from "../../images/carewindow.png";
import { logout } from 'js/Api/index';

function Sidebar({ selectedMenu, handleMenuClick, currentUserRole }) {
    const navigate = useNavigate();
    const isAdmin = currentUserRole === "Admin";
    const isSuperAdmin = currentUserRole === "SuperAdmin";
    const isManager = currentUserRole === "manager";
    const isStaff = currentUserRole === "staff";

    const handleLogout = async (e) => {
        e.preventDefault();
        try {
            const result = await logout();

            if (result.success) {
                localStorage.clear();
                navigate("/");
            } else {
                console.log("Logout failed.");
            }
        } catch (error) {
            console.log("Error:", error);
        }
    };

    return (
        <div className="dashboard dashboard_2">
            <nav id="sidebar" style={{ zIndex: 1049 }}>
                <div className="sidebar_blog_1">
                    <div className="sidebar-header">
                        <div
                            className="logo_section"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "0",
                            }}
                        >
                            <img
                                className="img-responsive"
                                src={carewindow}
                                alt="carewindow"
                                style={{ height: "52px" }}
                            />
                        </div>
                    </div>
                </div>
                <div className="sidebar_blog_2">
                    <ul
                        className="list-unstyled components"
                        style={{ marginTop: "50px" }}
                    >
                        {isAdmin || isSuperAdmin ? (
                            <li className={selectedMenu === "organizations" ? "active" : ""}>
                                <a href="#" onClick={() => handleMenuClick("organizations")}>
                                    <i className="fa fa-clock-o orange_color"></i>{" "}
                                    <span>Organisations</span>
                                </a>
                            </li>
                        ) : null}
                        {(isAdmin || isSuperAdmin) && (
                            <li className={selectedMenu === "admins" ? "active" : ""}>
                                <a href="#" onClick={() => handleMenuClick("admins")}>
                                    <i className="fa fa-diamond purple_color"></i>{" "}
                                    <span>Admins</span>
                                </a>
                            </li>
                        )}
                        {isStaff || isManager ? (
                            <li className={selectedMenu === "organization" ? "active" : ""}>
                                <a href="#" onClick={() => handleMenuClick("organization")}>
                                    <i className="fa fa-clock-o orange_color"></i>{" "}
                                    <span>Organisation</span>
                                </a>
                            </li>
                        ) : null}

                        <li className={selectedMenu === "customerSupport" ? "active" : ""}>
                            <a href="#" onClick={() => handleMenuClick("customerSupport")}>
                                <i className="fa fa-headphones blue_color"></i>{" "}
                                <span>Customer Support</span>
                            </a>
                        </li>
                        <li className={selectedMenu === "careWindowPlus" ? "active" : ""}>
                            <a href="#" onClick={() => handleMenuClick("careWindowPlus")}>
                                <i className="fa fa-plus yellow_color"></i>{" "}
                                <span>CareWindow Plus +</span>
                            </a>
                        </li>
                        <li className={selectedMenu === "puppyOfDay" ? "active" : ""}>
                            <a href="#" onClick={() => handleMenuClick("puppyOfDay")}>
                                <i className="fa fa-file-image-o brown_color"></i>{" "}
                                <span>Day Photos</span>
                            </a>
                        </li>
                        <li>

                        </li>
                        <li>
                            <a href="#" onClick={handleLogout}>
                                <i className="fa fa-sign-out red_color"></i>{" "}
                                <span>Log out</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    );
}

export default Sidebar;